module.exports = __webpack_public_path__ + "img/promocion.ea68e921.png";